export default __webpack_public_path__ + "static/media/WM0480.34I-43869_-26185_0.dd3008e6.jpg";